import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Snake} from '../snake/snake';
import {Board} from '../board/board';
import {Subscription} from 'rxjs';
import {GameSize} from '../../verliba-shared';

@Component({
  selector: 'app-tools',
  templateUrl: './tools.component.html',
  styleUrls: ['./tools.component.css']
})
export class ToolsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  board: Board;

  lives: Snake[] = [];
  private subscriptions: Subscription[];

  constructor(private gameSize: GameSize) { }

  get width(): number {
    return this.gameSize.width;
  }

  get mySnake(): Snake {
    return this.board?.snakes[0];
  }

  newLife(): void {
    const snake = new Snake(this.lives.length, 1, 't');
    this.lives.push(snake);
    snake.colorScheme = this.mySnake.colorScheme;
  }

  restart(): void {
    this.lives = [];
    if (!this.mySnake) { return; }
    for (let i = 0; i < this.mySnake.lives - 1; i ++) {
      this.newLife();
    }
  }

  ngOnInit(): void {
    this.restart();
    this.subscriptions = [this.board.events.subscribe((e) => {
      switch (e) {
        case 'died':
          if (this.lives.length) {
            this.lives.splice(this.lives.length - 1, 1);
          }
          break;
        case 'restart':
          this.restart();
          break;
        case 'life':
          this.newLife();
          break;
        // default: console.log(e); break;
      }
    })];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  get style(): any {
    return {
      width: `${this.width}px`,
      'min-height': `${this.width / 20}px`
    };
  }

  get livesStyle(): any {
    return {
      width: `${this.lives.length * this.width / 40}px`
    };
  }

  get scoreStyle(): any {
    return {
      'font-size': `${this.width / 20}px`
    };
  }

  ngAfterViewInit(): void {
  }
}
